module.exports = __webpack_public_path__ + "img/calendar.cfbbd1f3.png";